import React, { useEffect, createElement } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Home } from './pages/Home';
import { TendePayCaseStudy } from './pages/TendePayCaseStudy';
import { NovaCloudCaseStudy } from './pages/NovaCloudCaseStudy';
import { FlowKeyCaseStudy } from './pages/FlowKeyCaseStudy';
import { Blog } from './pages/Blog';
import { BlogPost } from './pages/BlogPost';
const HOME_CANONICAL_URL = 'https://yetudesignlab.com/';
export function App() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    const existingCanonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (pathname !== '/') {
      existingCanonical?.remove();
      return;
    }
    const canonical = existingCanonical ?? document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    canonical.setAttribute('href', HOME_CANONICAL_URL);
    if (!existingCanonical) {
      document.head.appendChild(canonical);
    }
  }, [pathname]);
  return <Routes data-id="element-0">
      <Route path="/" element={<Home data-id="element-2" />} data-id="element-1" />
      <Route path="/work/tende-pay" element={<TendePayCaseStudy data-id="element-4" />} data-id="element-3" />
      <Route path="/work/novacloud" element={<NovaCloudCaseStudy data-id="element-6" />} data-id="element-5" />
      <Route path="/work/flowkey" element={<FlowKeyCaseStudy data-id="element-8" />} data-id="element-7" />
      <Route path="/blog" element={<Blog data-id="element-10" />} data-id="element-9" />
      <Route path="/blog/:slug" element={<BlogPost data-id="element-12" />} data-id="element-11" />
    </Routes>;
}